import React from 'react';

export const UserSlideOverContext = React.createContext({
  userDetails: {},
  setUserDetails: () => {},
});
